export default __webpack_public_path__ + "static/media/LineSaleMockUp.6598a8d5.png";